import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { TradingOfferOperation } from 'types';

import TableBody from 'modules/_shared/Table/components/TableBody';

import TradingOfferOperationsTableRow from './TradingOfferOperationsTableRow';
import { useTradingOfferOperations } from '../context/TradingOfferOperationsContext';

const TradingOfferOperationsTableBody: FC = () => {
  const { t } = useTranslate();
  const { data } = useTradingOfferOperations();

  const hasData = data.tradingOfferOperations?.length > 0;

  const rows = data.tradingOfferOperations!.map(
    (operation: TradingOfferOperation, index: number) => (
      <TradingOfferOperationsTableRow
        key={operation._id ?? `operation-row-${index}`}
        index={index}
        operation={operation}
      />
    )
  );

  return (
    <TableBody
      hasData={hasData}
      content={rows}
      noDataMessage={t('NoOperationsAvailable')}
    />
  );
};

export default TradingOfferOperationsTableBody;
